import { useCoordinationClient } from '@confluence/engagement-provider';

import { CHANGEBOARDING_SPOTLIGHT_MESSAGE_ID } from './CoordinatedNav4ChangeboardingSpotlight';

export const useStopNav4Spotlight = (setActiveNav4Spotlight: (v: null) => void) => {
	const coordinationClient = useCoordinationClient();

	return () => {
		void coordinationClient.stop(CHANGEBOARDING_SPOTLIGHT_MESSAGE_ID);
		setActiveNav4Spotlight(null);
	};
};
